import React from "react";
import Navigation from "../../components/Navigation";
import Hero from "../../components/Hero";
import Portfolio from "../../components/Portfolio";
import TrustedBy from "../../components/TrustedBy";
import Contact from "../../components/Contact";
import Footer from "../../components/Footer";
import FAQ from "../../components/FAQ";
import Testimonials from "../../components/Testimonials";
import { Helmet } from "react-helmet-async";

const Index = () => {
  return (
    <div className="app-container">
      <Navigation />
      <Helmet>
        <title>Big Cat Graphics - Professional Graphic Design Services</title>
        <meta name="description" content="Big Cat Graphics offers top-notch graphic design services to bring your ideas to life. From logos and branding to marketing materials, we create visually stunning designs that captivate your audience and elevate your brand." />
      </Helmet>
      <Hero />
      <Portfolio />
      <TrustedBy />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
};

export default Index;
